<template>
    <!-- eslint-disable -->
    <svg
            v-bind="$attrs"
            class="check-mark"
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
    >
        <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.00002 11.2L1.80002 6.99998L0.400024 8.39998L6.00002 14L18 1.99998L16.6 0.599976L6.00002 11.2Z"
                :opacity="opacity"
                :fill="colorHexCode"
        />
    </svg>
    <!-- eslint-enable -->
</template>

<script>
import BaseIcon from '../../BaseIcon';

export default {
    name: 'CheckMarkIcon',
    extends: BaseIcon,
    data() {
        return {
            defaultColor: 'green',
        };
    },
};
</script>
